import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_NONPAYMENT_NONFEDERAL } from 'config/formSections/financial';

import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { DateSummary, Summary } from 'components/Summary';
import NonpaymentNonfederalItem from './NonpaymentNonfederalItem';

const sectionConfig = {
  key: FINANCIAL_NONPAYMENT_NONFEDERAL.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_NONPAYMENT_NONFEDERAL.name,
  storeKey: FINANCIAL_NONPAYMENT_NONFEDERAL.storeKey,
};

export class NonpaymentNonfederal extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
    this.summary = this.summary.bind(this);
  }

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const year = DateSummary(o?.Year);
    const taxType = (o?.TaxType || {}).value || '';

    return Summary({
      type: i18n.t('financial.pvq.nonpaymentNonfederal.summary.type'),
      index,
      left: taxType,
      right: year,
      placeholder: i18n.t('financial.pvq.nonpaymentNonfederal.summary.unknown'),
    });
  };

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasNonpaymentNonfederal: this.props.HasNonpaymentNonfederal,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasNonpaymentNonfederal = (values) => {
    this.update({
      HasNonpaymentNonfederal: values,
      List: values.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content nonpaymentnonfederal"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_NONPAYMENT_NONFEDERAL.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.nonpaymentnonfederal')}</h1>
        <Branch
          name="has_nonpaymentnonfederal"
          label={i18n.t('financial.pvq.nonpaymentNonfederal.branch.title')}
          labelSize="h4"
          className="nonpaymentnonfederal-branch"
          {...this.props.HasNonpaymentNonfederal}
          warning
          onUpdate={this.updateHasNonpaymentNonfederal}
          required={required}
          scrollIntoView={scrollIntoView}
          onError={this.handleError}
          attribute="HasNonpaymentNonfederal"
        />
        <Show when={(this.props.HasNonpaymentNonfederal || {}).value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            summary={this.summary}
            errors={accordionErrors}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.nonpaymentNonfederal.appendTitle')}
            attribute="List"
          >
            <NonpaymentNonfederalItem
              name="Item"
              formType={this.props.formType}
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

NonpaymentNonfederal.defaultProps = {
  List: EmptyListInstance,
  HasHasNonpaymentNonfederal: {},
  onUpdate: () => {},
  onError: (value, arr) => arr,
  defaultState: true,
  required: false,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(NonpaymentNonfederal, sectionConfig);
